import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { css } from "@emotion/core";
import FooterLogo from "../images/footer-logo.png";

const Footer = () => {
  const { shop, company, involved, service, bottom } = useStaticQuery(graphql`
    query {
      shop: sanityNav(title: { eq: "Footer / Shop" }) {
        links {
          title
          value
        }
      }
      company: sanityNav(title: { eq: "Footer / Our Company" }) {
        links {
          title
          value
        }
      }
      involved: sanityNav(title: { eq: "Footer / Get Involved" }) {
        links {
          title
          value
        }
      }
      service: sanityNav(title: { eq: "Footer / Customer Service" }) {
        links {
          title
          value
        }
      }
      bottom: sanityNav(title: { eq: "Footer / Bottom" }) {
        links {
          title
          value
        }
      }
    }
  `);
  return (
    <div
      css={css`
        background-color: #2d2d2d;
      `}
    >
      <footer
        css={css`
          max-width: 1280px;
          margin: 0px auto;
          font-size: 0.8125em;
          margin-top: 48px;
          padding: 20px 25px;
          color: #ffffff;
          a {
            text-decoration: none;
            transition: 0.3s;
            color: #ffffff;
            :hover {
              color: #3feae6;
            }
          }
          li {
            list-style: none;
            font-size: 20px;
            line-height: 24px;
            margin-bottom: 10px;
            font-weight: 400;
          }
          li:first-of-type {
            color: #3fc0bc;
          }
          > div {
            display: flex;
            justify-content: space-between;
            padding-top: 40px;
            padding-bottom: 5px;
            border-bottom: 1px solid #5e5e5e;
            text-transform: uppercase;
            @media (max-width: 890px) {
              flex-direction: column;
              li {
                display: inline-block;
                margin: 8px;
              }
            }
          }
          p {
            margin: 8px 0;
          }
          svg {
            margin: 4px;
          }
        `}
      >
        <div>
          <ul>
            <li>Shop:</li>
            {shop.links.map(link => (
              <li key={link.title}>
                <a href={link.value} target="_blank" rel="noopener noreferrer">
                  {link.title}
                </a>
              </li>
            ))}
          </ul>
          <ul>
            <li>Our Company:</li>
            {company.links.map(link => (
              <li key={link.title}>
                <a href={link.value} target="_blank" rel="noopener noreferrer">
                  {link.title}
                </a>
              </li>
            ))}
          </ul>
          <ul>
            <li>Get Involved:</li>
            {involved.links.map(link => (
              <li key={link.title}>
                <a href={link.value} target="_blank" rel="noopener noreferrer">
                  {link.title}
                </a>
              </li>
            ))}
          </ul>
          <ul>
            <li>Customer Service:</li>
            {service.links.map(link => (
              <li key={link.title}>
                <a href={link.value} target="_blank" rel="noopener noreferrer">
                  {link.title}
                </a>
              </li>
            ))}
          </ul>
          <div
            css={css`
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              @media (max-width: 890px) {
                margin: 20px auto;
              }
              > img {
                margin-left: auto;
                @media (max-width: 890px) {
                  margin: 20px auto;
                }
              }
            `}
          >
            <img width="120px" src={FooterLogo} alt="Nanocraft CBD's logo" />

            <ul
              css={css`
                display: flex;
              `}
            >
              <li>
                <a
                  href="https://twitter.com/nanocraftcbd/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="twitter"
                >
                  <svg
                    css={css`
                      transform: translate(6px, 2px);
                    `}
                    width="40"
                    viewBox="0 0 256 209"
                    preserveAspectRatio="xMidYMid"
                  >
                    <g>
                      <path
                        d="M256,25.4500259 C246.580841,29.6272672 236.458451,32.4504868 225.834156,33.7202333 C236.678503,27.2198053 245.00583,16.9269929 248.927437,4.66307685 C238.779765,10.6812633 227.539325,15.0523376 215.57599,17.408298 C205.994835,7.2006971 192.34506,0.822 177.239197,0.822 C148.232605,0.822 124.716076,24.3375931 124.716076,53.3423116 C124.716076,57.4586875 125.181462,61.4673784 126.076652,65.3112644 C82.4258385,63.1210453 43.7257252,42.211429 17.821398,10.4359288 C13.3005011,18.1929938 10.710443,27.2151234 10.710443,36.8402889 C10.710443,55.061526 19.9835254,71.1374907 34.0762135,80.5557137 C25.4660961,80.2832239 17.3681846,77.9207088 10.2862577,73.9869292 C10.2825122,74.2060448 10.2825122,74.4260967 10.2825122,74.647085 C10.2825122,100.094453 28.3867003,121.322443 52.413563,126.14673 C48.0059695,127.347184 43.3661509,127.988612 38.5755734,127.988612 C35.1914554,127.988612 31.9009766,127.659938 28.694773,127.046602 C35.3777973,147.913145 54.7742053,163.097665 77.7569918,163.52185 C59.7820257,177.607983 37.1354036,186.004604 12.5289147,186.004604 C8.28987161,186.004604 4.10888474,185.75646 0,185.271409 C23.2431033,200.173139 50.8507261,208.867532 80.5109185,208.867532 C177.116529,208.867532 229.943977,128.836982 229.943977,59.4326002 C229.943977,57.1552968 229.893412,54.8901664 229.792282,52.6381454 C240.053257,45.2331635 248.958338,35.9825545 256,25.4500259"
                        fill="#999999"
                      />
                    </g>
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/NanoCraftCBD/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="facebook"
                >
                  <svg
                    css={css`
                      transform: translate(-4px, -8px);
                    `}
                    width="44px"
                    viewBox="0 0 256 256"
                    preserveAspectRatio="xMidYMid"
                  >
                    <g>
                      <path
                        d="M176.635,256.001 L176.635,156.864 L209.912,156.864 L214.894,118.229 L176.635,118.229 L176.635,93.561 C176.635,82.375 179.742,74.752 195.783,74.752 L216.242,74.743 L216.242,40.188 C212.702,39.717 200.558,38.665 186.43,38.665 C156.932,38.665 136.738,56.67 136.738,89.736 L136.738,118.229 L103.376,118.229 L103.376,156.864 L136.738,156.864 L136.738,256.001 L176.635,256.001"
                        fill="#999999"
                      ></path>
                    </g>
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/nanocraftcbd/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="instagram"
                >
                  <svg
                    css={css`
                      transform: translate(-2px, -2px);
                    `}
                    width="40px"
                    viewBox="0 0 256 256"
                    preserveAspectRatio="xMidYMid"
                  >
                    <g>
                      <path
                        d="M127.999746,23.06353 C162.177385,23.06353 166.225393,23.1936027 179.722476,23.8094161 C192.20235,24.3789926 198.979853,26.4642218 203.490736,28.2166477 C209.464938,30.5386501 213.729395,33.3128586 218.208268,37.7917319 C222.687141,42.2706052 225.46135,46.5350617 227.782844,52.5092638 C229.535778,57.0201472 231.621007,63.7976504 232.190584,76.277016 C232.806397,89.7746075 232.93647,93.8226147 232.93647,128.000254 C232.93647,162.177893 232.806397,166.225901 232.190584,179.722984 C231.621007,192.202858 229.535778,198.980361 227.782844,203.491244 C225.46135,209.465446 222.687141,213.729903 218.208268,218.208776 C213.729395,222.687649 209.464938,225.461858 203.490736,227.783352 C198.979853,229.536286 192.20235,231.621516 179.722476,232.191092 C166.227425,232.806905 162.179418,232.936978 127.999746,232.936978 C93.8200742,232.936978 89.772067,232.806905 76.277016,232.191092 C63.7971424,231.621516 57.0196391,229.536286 52.5092638,227.783352 C46.5345536,225.461858 42.2700971,222.687649 37.7912238,218.208776 C33.3123505,213.729903 30.538142,209.465446 28.2166477,203.491244 C26.4637138,198.980361 24.3784845,192.202858 23.808908,179.723492 C23.1930946,166.225901 23.0630219,162.177893 23.0630219,128.000254 C23.0630219,93.8226147 23.1930946,89.7746075 23.808908,76.2775241 C24.3784845,63.7976504 26.4637138,57.0201472 28.2166477,52.5092638 C30.538142,46.5350617 33.3123505,42.2706052 37.7912238,37.7917319 C42.2700971,33.3128586 46.5345536,30.5386501 52.5092638,28.2166477 C57.0196391,26.4642218 63.7971424,24.3789926 76.2765079,23.8094161 C89.7740994,23.1936027 93.8221066,23.06353 127.999746,23.06353 M127.999746,0 C93.2367791,0 88.8783247,0.147348072 75.2257637,0.770274749 C61.601148,1.39218523 52.2968794,3.55566141 44.1546281,6.72008828 C35.7374966,9.99121548 28.5992446,14.3679613 21.4833489,21.483857 C14.3674532,28.5997527 9.99070739,35.7380046 6.71958019,44.1551362 C3.55515331,52.2973875 1.39167714,61.6016561 0.769766653,75.2262718 C0.146839975,88.8783247 0,93.2372872 0,128.000254 C0,162.763221 0.146839975,167.122183 0.769766653,180.774236 C1.39167714,194.398852 3.55515331,203.703121 6.71958019,211.845372 C9.99070739,220.261995 14.3674532,227.400755 21.4833489,234.516651 C28.5992446,241.632547 35.7374966,246.009293 44.1546281,249.28042 C52.2968794,252.444847 61.601148,254.608323 75.2257637,255.230233 C88.8783247,255.85316 93.2367791,256 127.999746,256 C162.762713,256 167.121675,255.85316 180.773728,255.230233 C194.398344,254.608323 203.702613,252.444847 211.844864,249.28042 C220.261995,246.009293 227.400247,241.632547 234.516143,234.516651 C241.632039,227.400755 246.008785,220.262503 249.279912,211.845372 C252.444339,203.703121 254.607815,194.398852 255.229725,180.774236 C255.852652,167.122183 256,162.763221 256,128.000254 C256,93.2372872 255.852652,88.8783247 255.229725,75.2262718 C254.607815,61.6016561 252.444339,52.2973875 249.279912,44.1551362 C246.008785,35.7380046 241.632039,28.5997527 234.516143,21.483857 C227.400247,14.3679613 220.261995,9.99121548 211.844864,6.72008828 C203.702613,3.55566141 194.398344,1.39218523 180.773728,0.770274749 C167.121675,0.147348072 162.762713,0 127.999746,0 Z M127.999746,62.2703115 C91.698262,62.2703115 62.2698034,91.69877 62.2698034,128.000254 C62.2698034,164.301738 91.698262,193.730197 127.999746,193.730197 C164.30123,193.730197 193.729689,164.301738 193.729689,128.000254 C193.729689,91.69877 164.30123,62.2703115 127.999746,62.2703115 Z M127.999746,170.667175 C104.435741,170.667175 85.3328252,151.564259 85.3328252,128.000254 C85.3328252,104.436249 104.435741,85.3333333 127.999746,85.3333333 C151.563751,85.3333333 170.666667,104.436249 170.666667,128.000254 C170.666667,151.564259 151.563751,170.667175 127.999746,170.667175 Z M211.686338,59.6734287 C211.686338,68.1566129 204.809755,75.0337031 196.326571,75.0337031 C187.843387,75.0337031 180.966297,68.1566129 180.966297,59.6734287 C180.966297,51.1902445 187.843387,44.3136624 196.326571,44.3136624 C204.809755,44.3136624 211.686338,51.1902445 211.686338,59.6734287 Z"
                        fill="#999999"
                      />
                    </g>
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://www.pinterest.com/nanocraftsciences/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="pinterest"
                >
                  <svg
                    css={css`
                      transform: translate(3px, -3px);
                    `}
                    width="40px"
                    viewBox="0 0 256 256"
                    preserveAspectRatio="xMidYMid"
                  >
                    <g>
                      <path
                        d="M0,128.002 C0,180.416 31.518,225.444 76.619,245.241 C76.259,236.303 76.555,225.573 78.847,215.848 C81.308,205.457 95.317,146.1 95.317,146.1 C95.317,146.1 91.228,137.927 91.228,125.848 C91.228,106.879 102.222,92.712 115.914,92.712 C127.557,92.712 133.182,101.457 133.182,111.929 C133.182,123.633 125.717,141.14 121.878,157.355 C118.671,170.933 128.686,182.008 142.081,182.008 C166.333,182.008 182.667,150.859 182.667,113.953 C182.667,85.899 163.772,64.901 129.405,64.901 C90.577,64.901 66.388,93.857 66.388,126.201 C66.388,137.353 69.676,145.217 74.826,151.307 C77.194,154.104 77.523,155.229 76.666,158.441 C76.052,160.796 74.642,166.466 74.058,168.713 C73.206,171.955 70.579,173.114 67.649,171.917 C49.765,164.616 41.436,145.031 41.436,123.015 C41.436,86.654 72.102,43.054 132.918,43.054 C181.788,43.054 213.953,78.418 213.953,116.379 C213.953,166.592 186.037,204.105 144.887,204.105 C131.068,204.105 118.069,196.635 113.616,188.15 C113.616,188.15 106.185,217.642 104.611,223.337 C101.897,233.206 96.585,243.07 91.728,250.758 C103.24,254.156 115.401,256.007 128.005,256.007 C198.689,256.007 256.001,198.698 256.001,128.002 C256.001,57.309 198.689,0 128.005,0 C57.314,0 0,57.309 0,128.002 Z"
                        fill="#999999"
                      />
                    </g>
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/channel/UCUG48SpjoiCEY17b6X-mejA"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="youtube"
                >
                  <svg
                    css={css`
                      transform: translate(6px, 4px);
                    `}
                    width="40px"
                    viewBox="0 0 256 180"
                    preserveAspectRatio="xMidYMid"
                  >
                    <defs>
                      <linearGradient
                        x1="49.9804764%"
                        y1="8.68053889e-07%"
                        x2="49.9804764%"
                        y2="100.030167%"
                        id="linearGradient-1"
                      >
                        <stop stopColor="#999999" offset="0%" />
                        <stop stopColor="#999999" offset="100%" />
                      </linearGradient>
                    </defs>
                    <g>
                      <g>
                        <path
                          d="M101.6,123.2 L170.8,87.4 L101.6,51.3 L101.6,123.2 L101.6,123.2 Z"
                          fill="#2d2d2d"
                        />
                        <path
                          d="M101.6,51.3 L162.3,91.8 L170.8,87.4 L101.6,51.3 L101.6,51.3 Z"
                          opacity="0.12"
                          fill="#420000"
                        />
                        <path
                          d="M253.301054,38.8 C253.301054,38.8 250.80203,21.2 243.105037,13.4 C233.408825,3.2 222.513081,3.2 217.415072,2.6 C181.729012,0 128.04998,0 128.04998,0 L127.95002,0 C127.95002,0 74.2709879,0 38.3850059,2.6 C33.3869582,3.2 22.4912144,3.2 12.695041,13.4 C5.09800859,21.2 2.59898477,38.8 2.59898477,38.8 C2.59898477,38.8 0,59.6 0,80.3 L0,99.7 C0,120.4 2.59898477,141.1 2.59898477,141.1 C2.59898477,141.1 5.09800859,158.7 12.795002,166.5 C22.4912144,176.7 35.2862163,176.4 40.9839906,177.4 C61.4759859,179.4 127.95002,180 127.95002,180 C127.95002,180 181.729012,179.9 217.515033,177.3 C222.513081,176.7 233.408825,176.7 243.204998,166.5 C250.901991,158.7 253.401015,141.1 253.401015,141.1 C253.401015,141.1 256,120.4 256,99.7 L256,80.3 C255.900039,59.6 253.301054,38.8 253.301054,38.8 L253.301054,38.8 Z M101.560328,123.2 L101.560328,51.3 L170.733307,87.4 L101.560328,123.2 L101.560328,123.2 Z"
                          fill="url(#linearGradient-1)"
                        />
                      </g>
                    </g>
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <p>
          © 2019 NanoCraft Sciences LLC. All Rights Reserved
          {bottom.links.map(link => (
            <span key={link.title}>
              {" / "}
              <a href={link.value} target="_blank" rel="noopener noreferrer">
                {link.title}
              </a>
            </span>
          ))}
        </p>
        <p>
          <strong>DISCLAIMER </strong> - THC content level of .03% or less.
          Pregnant women are advised to consult their primary care provider or
          physician before using this product.
        </p>
        <p>
          <strong>FDA DISCLAIMER </strong> - - The statements and products
          referred to throughout this site have not been evaluated by the FDA.
          They are not intended to diagnose, treat, cure or prevent any disease
          or condition. If you have a health condition or concern, consult a
          physician or your health care provider. Always consult a medical
          doctor before modifying your diet, using any new product, drug,
          supplement, or doing new exercises. We recommend you educate
          yourselves on the scientific / nutritional facts.
        </p>
      </footer>
    </div>
  );
};

export default Footer;
